import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import GetUsername from "../components/resetpassword/getusername";
import { useEffect, useState } from "react";
import OTP from "../components/resetpassword/otp";
import ResetChangePassword from "../components/resetpassword/resetchangepassword";
import { useNavigate } from "react-router-dom";

const steps = ["Find Your Account", "Verification", "Reset Password"];

const ResetPassword = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set<number>());
  const [username, setUsername] = useState("");
  let navigate = useNavigate();

  const isStepOptional = (step: number) => {
    return step === 1;
  };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleReturn = () => {
    // setActiveStep(0);
    navigate("/login")
  };

  return (
    <>
    <div className="mt-20">
        <div className="flex flex-wrap">
      <div className="xl:mx-72 h-fit bg-white object-center shadow overflow-hidden sm:rounded-md w-5/6" >
      <Box sx={{ width: "100%" }}>
        <Stepper activeStep={activeStep}>
          {steps.map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: {
              optional?: React.ReactNode;
            } = {};
            if (isStepSkipped(index)) {
              stepProps.completed = false;
            }
            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Typography sx={{ mt: 2, mb: 1 }}>
              You have successfully reset your password!
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button onClick={handleReturn}>Return to Login</Button>
            </Box>
          </React.Fragment>
        ) : activeStep === 2 ? (
          <React.Fragment>
            <ResetChangePassword handleNext={handleNext} username={username} />
          </React.Fragment>
        ) : activeStep === 1 ? (
          <React.Fragment>
            <OTP handleNext={handleNext} username={username} />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <GetUsername handleNext={handleNext} username={setUsername} />
          </React.Fragment>
        )}
      </Box>
      </div>
      </div>
      </div>
    </>
  );
};

export default ResetPassword;
